module.exports = __webpack_public_path__ + "img/logo.81c22938.png";